import request from '../http/request';
// 列表
export function getList(params) {
  return request('/riskcontrol/global/phrase/list', { method: 'GET', params });
}
// 查询所有消息
export function getAllList(params) {
  return request('/riskcontrol/global/phrase/allList', { method: 'GET', params });
}

export function addPhrase(params) {
  return request('/riskcontrol/global/phrase', { method: 'POST', params });
}

export function updatePhrase(params) {
  return request('/riskcontrol/global/phrase', { method: 'PUT', params });
}

export function delPhrase(params) {
  return request(`/global/phrase?id=${params.id}`, { method: 'DELETE', params });
}
